import emiter, { _EVENTS } from '../../../events';
import { _APIS } from 'apis';
import request from 'request';
import { DEFAULT_PAGE_INFO } from "consts";


export const useDidiSection = () => {

  const search = (params: any) => request.post(_APIS.ACTIVES.DIDI_SECTION.LIST,  params)

  const searchFormReset = (form: any) => {
    emiter.emit(_EVENTS.ACTIVES.DIDI_SECTION.SEARCH, {
      ...form.getFieldsValue(),
      ...DEFAULT_PAGE_INFO
    });
  };
  const searchFormFinish = (form: any) => {
    emiter.emit(_EVENTS.ACTIVES.DIDI_SECTION.SEARCH, {
      ...form.getFieldsValue(),
      ...DEFAULT_PAGE_INFO
    });
  };

  const tablePagination = (data: any) => {
    emiter.emit(_EVENTS.ACTIVES.DIDI_SECTION.SEARCH, data);
  }



  return {
    search,
    searchFormReset,
    searchFormFinish,
    tablePagination
    }
};
